import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { buildSignupServiceCategories } from '../../data/signupCategories';

/**
 * Load Trade Categories + Trade Subcategories from local spec data.
 * No API for now — graphqlService is accepted so existing callers keep working.
 */
export const fetchServiceCategories = createAsyncThunk(
  'serviceCategories/fetchCategories',
  async () => buildSignupServiceCategories()
);

const initialState = {
  categories: [],
  loading: false,
  error: null
};

const serviceCategoriesSlice = createSlice({
  name: 'serviceCategories',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchServiceCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchServiceCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export default serviceCategoriesSlice.reducer;
